module.exports = __webpack_public_path__ + "static/media/patil.66778453.png";